const ns = 'http://www.w3.org/2000/svg';
function node(name, attrs) {
    const result = document.createElementNS(ns, name);
    Object.entries(attrs).forEach(([key, value]) => result.setAttribute(key, value));
    return result;
}

// Provisional display guide only. Production retains the complete rectangular crop.
export function stickerGuide(x, y, width, height, insetFraction, radiusFraction) {
    const shortSide = Math.min(width, height);
    const inset = shortSide * insetFraction, radius = shortSide * radiusFraction;
    const left = x + inset, top = y + inset, right = x + width - inset, bottom = y + height - inset;
    const group = node('g', {});
    const rounded = `M${left + radius} ${top} H${right - radius} Q${right} ${top} ${right} ${top + radius} V${bottom - radius} Q${right} ${bottom} ${right - radius} ${bottom} H${left + radius} Q${left} ${bottom} ${left} ${bottom - radius} V${top + radius} Q${left} ${top} ${left + radius} ${top} Z`;
    group.append(node('path', { class: 'print-crop-mask', 'fill-rule': 'evenodd',
        d: `M${x} ${y} h${width} v${height} h${-width} Z ${rounded}` }));
    for (const className of ['sticker-cut-contrast', 'sticker-cut-line']) {
        group.append(node('rect', { class: className, x: left, y: top, width: width - 2 * inset,
            height: height - 2 * inset, rx: radius, 'vector-effect': 'non-scaling-stroke' }));
    }
    return group;
}

export function stickerSheet(photo, effect, crop, count, inset, radius, showGuides = true, columnCount) {
    const columns = columnCount ?? (count === 8 && crop.width > crop.height ? 2 : 4);
    const rows = count / columns;
    const svg = node('svg', { viewBox: `0 0 ${columns * crop.width} ${rows * crop.height}`, 'aria-hidden': 'true' });
    for (let i = 0; i < count; i++) {
        const tile = node('svg', { x: (i % columns) * crop.width, y: Math.floor(i / columns) * crop.height,
            width: crop.width, height: crop.height, viewBox: `${crop.x} ${crop.y} ${crop.width} ${crop.height}`, overflow: 'hidden' });
        const image = node('image', { href: photo.url, width: photo.width, height: photo.height });
        image.style.filter = effect === 'Sepia' ? 'sepia(100%)' : effect === 'BlackWhite' ? 'grayscale(100%)' : 'none';
        tile.append(image);
        if (showGuides) tile.append(stickerGuide(crop.x, crop.y, crop.width, crop.height, inset, radius));
        svg.append(tile);
    }
    return svg;
}
